import { render } from "./ControlsLeftComponent.vue?vue&type=template&id=63f9996d&scoped=true"
import script from "./ControlsLeftComponent.vue?vue&type=script&lang=ts"
export * from "./ControlsLeftComponent.vue?vue&type=script&lang=ts"

import "./ControlsLeftComponent.vue?vue&type=style&index=0&id=63f9996d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-63f9996d"

export default script